import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import Marquee from "@/components/Marquee";
import { waLink, WhatsAppIcon } from "@/lib/whatsapp";

export default function About() {
  useEffect(() => {
    document.title = "About AutoWorld — Honda · Proton · Jaecoo & Omoda";
  }, []);

  return (
    <div className="pt-16 md:pt-20" data-testid="about-page">
      <section className="border-b border-black/10">
        <div className="mx-auto max-w-[1400px] px-5 py-14 md:px-10 md:py-24">
          <Reveal>
            <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-neutral-500">Honda · Proton · Jaecoo &amp; Omoda</div>
            <h1 className="mt-4 font-display font-extrabold uppercase tracking-tighter" style={{ fontSize: "clamp(1.9rem, 8.2vw, 6rem)", lineHeight: 1.02 }}>
              The Source.<br /><span className="text-stroke">Not a Middleman.</span>
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-neutral-600">
              AutoWorld brings Honda, Proton, and Jaecoo &amp; Omoda together under one roof.
              When you buy from us, you buy from the source — no agent layers, no markup chains,
              no mystery fees. That's why our price is the best price.
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee items={["No Agent", "Honda", "Proton", "Jaecoo & Omoda", "Direct Since Day One"]} />

      <section className="bg-black text-white">
        <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-28">
          <Reveal>
            <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-neutral-400">Why "direct" matters</div>
            <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold uppercase tracking-tighter md:text-6xl">
              Every ringgit of markup you don't pay is a ringgit in your pocket
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-px border border-white/15 bg-white/15 md:grid-cols-3">
            {[
              ["Agent Route", "Car → agent → you. Every hand adds a fee you'll never see itemised.", true],
              ["AutoWorld Route", "Car → us → you. One price, quoted direct from the source.", false],
              ["Your Win", "Best price guaranteed, full aftersales, and someone accountable — every single time.", true],
            ].map(([t, d, dark], i) => (
              <Reveal key={t} delay={i * 0.08} className={`p-8 md:p-10 ${dark ? "bg-black" : "bg-white text-black"}`}>
                <div className={`font-mono text-[9px] uppercase tracking-[0.3em] ${dark ? "text-neutral-500" : "text-neutral-400"}`}>{String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-3 font-display text-2xl font-bold uppercase tracking-tight">{t}</h3>
                <p className={`mt-3 text-sm leading-relaxed ${dark ? "text-neutral-400" : "text-neutral-600"}`}>{d}</p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12 flex flex-wrap gap-3">
            <Link to="/models" data-testid="about-models-cta" className="group flex items-center gap-2 bg-white px-7 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-black hover:bg-neutral-200">
              See the cars <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="about-whatsapp-cta" className="flex items-center gap-2 border border-white px-7 py-4 font-mono text-[11px] uppercase tracking-[0.25em] hover:bg-white hover:text-black">
              <WhatsAppIcon className="h-4 w-4" /> Talk to us
            </a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
